"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayData = void 0;
const ModelCommon_1 = require("./ModelCommon");
const ModelTypes_1 = require("../types/ModelTypes");
const typeName = 'GatewayData';
class GatewayData extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, ob);
    }
    getLatLon() {
        let res = undefined;
        const { latitude: lat, longitude: lng } = this;
        if ((0, ModelTypes_1.isGeofencePointsType)({ lat, lng }))
            res = { lat, lng };
        else {
            console.log(`could not get posiition on Gateway ${this.name}, with `, { lat, lng });
        }
        return res;
    }
}
exports.GatewayData = GatewayData;
